















































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import api from '../../../api/index'
import CloseIcon from '../CloseIcon.vue'

@Component({
  components: {
    CloseIcon
  }
})
export default class GroupUsers extends Vue {
  @Prop({ type: Boolean, required: true }) isActive!: boolean
  @Prop({ type: Number, required: true }) id!: number
  @Prop({ type: Object, required: true, default: () => ({}) }) editedGroup!: any

  // COMMON
  tabs: string[] = [
    'Utilisateurs',
    'Import XLSX',
    'Créer un utilisateur'
  ]
  currentTab: string = this.tabs[0]
  errorMessage: string[] = []

  closeModal() {
    this.currentTab = this.tabs[0]
    this.resetModal()
    this.$emit("close");
  }

  resetModal() {
    this.errorMessage = []
    this.selectedUser = null
    this.selectedUserError = false
    this.xlsFile = null
    Object.keys(this.userFields).forEach(field => {
      this.userFields[field].value = this.userFieldsDefault[field]
      if (this.userFields[field].isValid !== undefined) {
        this.userFields[field].isValid = null
      }
    })
  }

  @Watch('currentTab')
  tabChange() {
    this.errorMessage = []
  }

  // USERS LIST
  usersCurrentPage = 1;
  usersPerPage = 10;

  get usersTotalPages() {
    if (!this.editedGroup.users || this.editedGroup.users.length <= this.usersPerPage) return 0
    return Math.ceil(this.editedGroup.users.length / this.usersPerPage)
  }

  get usersList() {
    if (!this.editedGroup.users || this.editedGroup.users < 1) return []
    const startIndex = (this.usersCurrentPage - 1) * this.usersPerPage
    return this.editedGroup.users.slice(startIndex, startIndex + this.usersPerPage)
  }

  async removeUser(id) {
    try {
      const res = await api.delete(`bo/groups/${this.editedGroup.id}/memberships/${id}`)
      this.$emit("success", res.data)
    } catch (error) {
      if (error.response.status === 422 && Array.isArray(error.response.data.errors)) {
        error.response.data.errors.forEach((e) => {
          this.errorMessage.push(e);
        })
        return
      }
      this.errorMessage.push('Une erreur s\'est produite')
    }
  }

  // FIND USER
  fetchedUsers = []
  selectedUser: any = null
  fetching: boolean = false
  fetchTimer?: number = undefined
  selectedUserError: boolean = false

  async fetchUsers(term) {
    if (term.length === 0) {
      this.fetchedUsers = []
      return
    }
    if (this.fetchTimer || this.fetching) {
      clearTimeout(this.fetchTimer)
    }
    this.fetchTimer = setTimeout(async () => {
      this.fetching = true
      try {
        const res = await api.get(
          `bo/users`,
          {
            params: {
              per_page: 10,
              keywords: term
            }
          }
        )
        this.fetchedUsers = res.data.map((user: any) => {
          return {
            ...user,
            displayName: `${user.first_name} ${user.last_name} (${user.mobile_phone_number || user.email || '-'})`
          }
        })
        this.fetching = false
      } catch (error) {
        this.fetching = false
        this.errorMessage.push('Une erreur s\'est produite')
      }
    }, 500)
  }

  focusUserFinder() {
    if (this.selectedUserError && this.$refs.userFinder) {
      // @ts-ignore
      this.$refs.userFinder.setSelected('')
    }
  }

  selectUser(user) {
    this.selectedUserError = false
    if (this.editedGroup.users.find(u => u.id === user.id)) {
      this.selectedUserError = true
      return
    }
    this.selectedUser = user
  }

  async addUser(userId?: number) {
    try {
      const res = await api.post(
        `bo/groups/${this.editedGroup.id}/memberships`,
        {
          membership: {
            user_id: typeof userId !== 'undefined' ? userId : this.selectedUser.id
          }
        }
      )
      this.$emit("success", res.data)
      this.selectedUser = null
      // @ts-ignore
      if (this.$refs.userFinder) this.$refs.userFinder.setSelected('')
      if (userId) {
        this.existingUser = null
        this.resetModal()
        this.currentTab = this.tabs[0]
      }
    } catch (error) {
      if (error.response.status === 422 && Array.isArray(error.response.data.errors)) {
        error.response.data.errors.forEach((e) => {
          this.errorMessage.push(e);
        })
        return
      }
      this.errorMessage.push('Une erreur s\'est produite')
    }
  }

  // XLSX IMPORT
  uploading: boolean = false
  dragCounter: number = 0
  xlsFile: any = null

  get xlsExampleUrl() {
    return "//" + process.env.VUE_APP_API_HOST + "/utilisateurs-groupes.xlsx";
  }

  handleDrop(e) {
    this.dragCounter = 0
    const files = e.dataTransfer.files
    if (files.length === 0) return
    this.fileSelected(files[0])
  }

  fileSelected(file) {
    this.errorMessage = []
    if (file && !this.isAcceptedFileType(file)) {
      this.errorMessage.push('Seuls les fichiers .xlsx sont acceptés')
      return
    }
    this.xlsFile = file
  }

  isAcceptedFileType(file: any) {
    return file.name.slice(file.name.lastIndexOf('.'), file.name.length) === '.xlsx'
  }

  async uploadFile() {
    if (this.uploading) return
    this.uploading = true
    try {
      const form = new FormData();
      form.append("file", this.xlsFile);
      const res = await api.post(
        `bo/condominiums/${this.id}/groups/${this.editedGroup.id}/user_import`,
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      this.$emit("success", res.data)
      this.currentTab = this.tabs[0]
      this.uploading = false
    } catch (error) {
      this.uploading = false
      if (error.response.status === 422 && Array.isArray(error.response.data.errors)) {
        error.response.data.errors.forEach((e) => {
          this.errorMessage.push(`Ligne: ${e.line_number} - ${e.title}`);
        })
        return
      }
      this.errorMessage.push('Une erreur s\'est produite')
    }
  }

  // CREATE USER
  userFields: { [key:string]: any } = {
    phoneCode: {
      value: '33',
      check: v => v.length > 0,
      isValid: null,
      error: 'Le code pays du numéro de téléphone doit être défini'
    },
    phoneNumber: {
      value: '',
      check: v => v.length > 0,
      isValid: null,
      error: 'Le numéro de téléphone doit être défini'
    },
    first_name: {
      value: '',
      check: v => v.length > 0,
      isValid: null,
      error: 'Le prénom doit être défini'
    },
    last_name: {
      value: '',
      check: v => v.length > 0,
      isValid: null,
      error: 'Le nom doit être défini'
    },
  }
  userFieldsDefault = Object.keys(this.userFields)
    .reduce((a, v) => ({ ...a, [v]: this.userFields[v].value }), {})
  existingUser?: any = null

  validateUserForm() {
    Object.keys(this.userFields)
      .filter(field => this.userFields[field].check !== undefined)
      .forEach(field => {
        this.userFields[field].isValid = this.userFields[field].check(this.userFields[field].value)
      })
    return !Object.keys(this.userFields).some(field => this.userFields[field].isValid === false)
  }

  async newUser() {
    this.errorMessage = []
    if (!this.validateUserForm()) {
      return
    }
    try {
      const user: { [key: string]: string } = {
        mobile_phone_number: `+${this.userFields.phoneCode.value}${this.userFields.phoneNumber.value}`,
        ...Object.keys(this.userFields)
          .reduce((a, v) => ({ ...a, [v]: this.userFields[v].value }), {})
      }
      delete user.phoneCode
      delete user.phoneNumber
      const res = await api.post(
        `bo/groups/${this.editedGroup.id}/users`,
        {
          user
        }
      )
      this.$emit("success", res.data)
      this.currentTab = this.tabs[0]
      this.resetModal()
    } catch (error) {
      if (error.response.status === 422 && Array.isArray(error.response.data.errors)) {
        error.response.data.errors.forEach((e) => {
          this.errorMessage.push(e);
        })
        return
      }
      if (error.response.status === 400) {
        if (this.editedGroup.users.some((user: any) => user.id === error.response.data.id)) {
          this.errorMessage.push(`Le compte associé à ce numéro de téléphone "${error.response.data.first_name} ${error.response.data.last_name}" est déjà associé à ce groupe.`)
        } else {
          this.errorMessage.push(`Ce numéro de téléphone est déjà associé au compte de "${error.response.data.first_name} ${error.response.data.last_name}"`)
          this.existingUser = error.response.data
        }
        return
      }
      this.errorMessage.push('Une erreur s\'est produite')
    }
  }
}
